import { Theme } from "@mui/material";

export function generateFormLabelTypographyProps(theme: Theme) {
  return {
    variant: "subtitle1",
    sx: {
      color: theme.palette.text.primary,
      fontWeight: "bold",
      textAlign: "end",
      textTransform: "none",
    },
  };
}
